module.exports = {"530628001":"角奎街道","530628002":"发界街道","530628102":"洛泽河镇","530628103":"牛街镇","530628104":"海子镇","530628105":"荞山镇","530628106":"龙安镇","530628107":"钟鸣镇","530628108":"两河镇","530628109":"小草坝镇","530628110":"龙海镇","530628201":"龙街苗族彝族乡","530628202":"奎香苗族彝族乡","530628203":"树林彝族苗族乡","530628211":"柳溪苗族乡","530628212":"洛旺苗族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530628.json
// module id = 2722
// module chunks = 0